module.exports = __webpack_public_path__ + "img/artillery-wagon-cannon-barrel-2.39690ea7.png";